export function otherServicesSlider() {

    const otherServicesSlider = document.querySelector('.js-otherServicesSlider');

    if (!otherServicesSlider) {
        return false;
    }


    $('.js-otherServicesSlider').not('.slick-initialized').slick({
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        dotsClass: 'other-services_dots',
        prevArrow: '<button type="button" class="other-services_arrow-prev"></button>',
        nextArrow: '<button type="button" class="other-services_arrow-next"></button>',
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    arrows: false,
                    dots: true,
                }
            }
        ]
    });

}